export const GTM_ID = 'GTM-NQPFZPJ';

export const GTM_SCRIPT = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s);j.async=true;j.src="https://load.gtm.themens.com.br/31kyhcgknmvd.js?"+i;
f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','exi782n5=DRJQKT8qTiY1Jis0Oy1FHllEQ19NAw1VEB4IAw4JEEYHGQBACRU%3D');`;

export const GTM_IFRAME_URL = `https://load.gtm.themens.com.br/ns.html?id=${GTM_ID}`;


export const GTM_VALID_PATHS = [
  'consultoriomedico.digital',
  '/questionario/',
  '/questionario/feedback'
];
